import styled from 'styled-components';

import Select from 'components/Select';

const StyledSelect = styled(Select)`
  width: ${(props) => props.width || 240}px;
`;

const StyledSelectorHack = styled.div`
  position: relative;
  top: -7px;
  line-height: normal;
`;

const StyledSelectorPlaceholder = styled.div`
  color: var(--greyWolf);
`;

export { StyledSelect, StyledSelectorHack, StyledSelectorPlaceholder };
